/**
 * Registry-code validation and the copy for a failed onboarding lookup.
 *
 * The API answers in English with a machine-readable `code`, so that code — not
 * the API's text — is what decides which message the user sees.
 *
 * Both onboarding screens are translated, so the only accessor is
 * `lookupErrorKey`: the copy itself lives in the three locale files under
 * `onboarding.errors.*`.
 */

/** Estonian registry codes are exactly eight digits — same rule as the API. */
export const REGISTRY_CODE_RE = /^\d{8}$/;

export function isValidRegistryCode(code: string): boolean {
  return REGISTRY_CODE_RE.test(code);
}

export type LookupFailure = 'invalidCode' | 'notFound' | 'unavailable' | 'rateLimited' | 'generic';

export function lookupFailureKind(code?: string): LookupFailure {
  switch (code) {
    case 'invalid_registry_code':
      return 'invalidCode';
    case 'registry_not_found':
      return 'notFound';
    case 'registry_unavailable':
      return 'unavailable';
    case 'rate_limited':
      return 'rateLimited';
    default:
      return 'generic';
  }
}

/** Translation key for the failure, for the pages that use `useTranslation()`. */
export function lookupErrorKey(code?: string): string {
  return `onboarding.errors.${lookupFailureKind(code)}`;
}
